import { Row, Col, Container, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faCreditCard, faClock, faSmile, faPlay } from '@fortawesome/free-solid-svg-icons';
import SectionFourImg from '../../../Assets/Images/header_sectionFour.svg';

import './style.scss';

const SectionFour = () => {
  const navigate = useNavigate();

  return (
    <section id="sectionFour" className="py-5">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="d-none d-md-block text-center mb-4 mb-md-0">
            <div className="image-wrapper">
              <div className="decorative-circle circle-1"></div>
              <div className="decorative-circle circle-2"></div>
              <img 
                src={SectionFourImg} 
                className="img-fluid main-image" 
                alt="Seamless mobile ordering and payment interface showing easy restaurant booking and quick checkout process" 
                loading="lazy"
              />
            </div>
          </Col>
          <Col xs={12} md={6} className="text-center text-md-start">
            <div className="sectionFour-text">
              <div className="section-badge mb-3">
                <span>Why Jamlyf Works</span>
              </div>
              <h2 className="headerText display-5 fw-bold mb-4">
                <span className="highlight">Effortless</span> Dining Experience
              </h2>
              <p className="lead mb-5 section-description">
                Focus on what matters most - enjoying great food and memorable moments. 
                Our streamlined ordering and tab management system reduces wait times and 
                order mistakes, so you can spend more time socializing and less time worrying.
              </p>
              
              <div className="benefits-grid row g-3 mb-5">
                <div className="col-6">
                  <div className="benefit-item">
                    <div className="benefit-icon icon-warning">
                      <FontAwesomeIcon icon={faClock} />
                    </div>
                    <h6 className="benefit-title">Lesser Wait Times</h6>
                    <small className="benefit-desc">Skip the queues to make an order</small>
                  </div>
                </div>
                <div className="col-6">
                  <div className="benefit-item">
                    <div className="benefit-icon icon-primary">
                      <FontAwesomeIcon icon={faMobileAlt} />
                    </div>
                    <h6 className="benefit-title">Digital Orders</h6>
                    <small className="benefit-desc">Order in seconds</small>
                  </div>
                </div>
                <div className="col-6">
                  <div className="benefit-item">
                    <div className="benefit-icon icon-success">
                      <FontAwesomeIcon icon={faCreditCard} />
                    </div>
                    <h6 className="benefit-title">Easy price checks</h6>
                    <small className="benefit-desc">Stay within budget</small>
                  </div>
                </div>
                <div className="col-6">
                  <div className="benefit-item">
                    <div className="benefit-icon icon-teal">
                      <FontAwesomeIcon icon={faSmile} />
                    </div>
                    <h6 className="benefit-title">More Fun</h6>
                    <small className="benefit-desc">Focus on enjoying</small>
                  </div>
                </div>
              </div>

              <div className="cta-section">
                <h5 className="cta-title mb-3">Ready to transform your dining experience?</h5>
                <div className="button-group d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-md-start">
                  <Button className="watchDemo">
                    <FontAwesomeIcon icon={faPlay} className="me-2" />
                    Watch Demo
                  </Button>
                  <Button className="learnMore" onClick={() => navigate("/business")}>
                    Learn More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SectionFour;
